<template>
  <div class="addbrand">
    <div class="searchTop2">
      <div class="searchTop2_c">
        <input
          placeholder="输入品牌/行业"
          value="inputVal"
          v-model="inputVal"
          @input="inputValue($event.target.value)"
        />
        <!-- <router-link :to="{ path: '/' }" tag="div" class="searchBtn"
          >完成</router-link
        > -->
        <!-- <div class="searchBtn" @click="sousuoBrand">搜索品牌行业</div> -->
        <div class="searchBtn" @click="goOver">完成</div>
      </div>
    </div>
    <div style="height: 1.2rem"></div>
    <div class="main_search">
      <div class="myGuanzhu_title" v-if="gzBrand.length > 0">
        我的关注<span>（可选多个）</span>
      </div>
      <div class="guanzhu_tag">
        <span
          v-for="(item, index) in gzBrand"
          :key="index"
          @click="getFollowCancelNew(item.id)"
          >{{ item.title }}</span
        >
      </div>
      <div v-if="searchZ" style="text-align: center;">搜索中......</div>
      <div class="addbrandA" v-if="nodataSearch" @click="showAddBrandDialog">
        找不到相关内容，创建自己的品牌 没有我的品牌/行业？>
      </div>
      <div class="chooseBrandTitle" v-if="brandList.length > 0">选择品牌</div>
      <ul class="box">
        <li
          @click="changeList(item, 2)"
          :key="index"
          v-for="(item, index) in brandList"
        >
          <img :src="item.src" />
          <div>{{ item.title }}</div>
        </li>
      </ul>
      <div class="chooseBrandTitle" v-if="cateList.length > 0">选择行业</div>
      <ul class="box">
        <li
          @click="changeList(item, 1)"
          :key="index"
          v-for="(item, index) in cateList"
        >
          <img :src="item.src" />
          <div>{{ item.cat_title }}</div>
        </li>
      </ul>
    </div>
    <!-- 创建品牌 -->
    <div class="dialog addBrandDialog" v-if="addBrandDialog">
      <div class="addContent">
        <div class="add1">
          是否把<br /><span>【{{ inputVal }}】</span><br />创建成自己的品牌
        </div>
        <div class="add2 addchooseHy" @click="goPage">
          我没有品牌/公司，点击去选择行业>
        </div>
        <div class="addbtns">
          <span @click="quxiaoAdd">取消</span>
          <span @click="createdBrand">创建</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@assets/css/search.css";
import {
  getShare,
  follow,
  getFollowLstNew,
  getBrandSaveNew,
  getBrandLst,
  getFollowCancelNew,
  getFollowFollowNew,
} from "@api/public";
import cookie from "@utils/store/cookie";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import { goShopDetail } from "@libs/order";
import { Toast } from "vant";
const HAS_COUPON_WINDOW = "has_coupon_window";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
const MAPKEY = "mapKey";
let vm = null;
export default {
  name: "Index",
  components: {},
  props: {},
  data: function() {
    return {
      searchZ: false,
      nodataSearch: false,
      gzBrand: [], //我的关注品牌
      gzHangye: [], //我关注的行业
      inputVal: "",
      cateList: [], //已存在的行业
      brandList: [], //已存在的品牌列表
      addBrandDialog: false,
      newGoodsBananr: "",
      isWeixin: isWeixin(),
      followUrl: "",
      subscribe: false,
      followHid: false,
      followCode: false,
      showCoupon: false,
      logoUrl: "",
      banner: [],
      menus: [],
      roll: [],
      activity: [],
      activityOne: {},
      info: {
        fastList: [],
        bastBanner: [],
        firstList: [],
        bastList: [],
      },
      likeInfo: [],
      lovely: [],
      benefit: [],
      couponList: [],
      mapKey: "",
      searchD: "",
    };
  },
  created() {
    vm = this;
  },
  mounted: function() {
    vm.setOpenShare();
    console.log(this.$router);
    this.getFollowLstNew(); //初始获取我关注的品牌
  },
  methods: {
    goPage() {
      this.$router.push({ path: "/jiaodian/brand" });
    },
    // 获取我关注的行业/品牌
    getFollowLstNew() {
      getFollowLstNew().then((res) => {
        if (res.data) {
          this.gzBrand = res.data.brand;
          this.gzHangye = res.data.cate;
        }
      });
    },
    goOver() {
      this.$router.go(-1); //返回上一层
    },
    // sousuoBrand() {
    //   this.brandList = [];
    //   this.cateList = [];
    //   this.getBrandLst();
    // },
    // 实时监听输入
    inputValue(e) {
      clearTimeout(this.searchD);
      this.searchZ = true;
      this.nodataSearch = false;
      this.inputVal = e;
      this.brandList = [];
      this.cateList = [];
      this.getBrandLst();
    },
    getBrandLst() {
      const that = this;
      getBrandLst(that.inputVal).then((res) => {
        that.brandList = res.data.brandList;
        that.cateList = res.data.cateList;
        console.log("that.brandList.length:", that.brandList.length);
        console.log("that.cateList.length:", that.cateList.length);
        if (that.brandList.length == 0 && that.cateList.length == 0) {
          console.log("未找到数据");
          that.searchD = setTimeout(function() {
            that.searchZ = false;
            that.nodataSearch = true;
          }, 300);
        }
        if (that.gzBrand.length >= 0) {
          for (let i = 0; i < that.brandList.length; i++) {
            let isHave = that.gzBrand.find(
              (item) => item.pid == that.brandList[i].id
            );
            if (isHave != undefined) {
              that.brandList[i].checked = true;
              that.brandList[i].pid = isHave.id;
              that.brandList[i].src =
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_choose2.png";
            } else {
              that.brandList[i].checked = false;
              this.brandList[i].src =
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_choose1.png";
            }
          }
        }
        if (that.gzHangye.length >= 0) {
          for (let i = 0; i < that.cateList.length; i++) {
            let isHave = that.gzHangye.find(
              (item) => item.pid == that.cateList[i].id
            );
            if (isHave != undefined) {
              this.cateList[i].checked = true;
              that.cateList[i].pid = isHave.id;
              this.cateList[i].src =
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_choose2.png";
            } else {
              this.cateList[i].checked = false;
              this.cateList[i].src =
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_choose1.png";
            }
          }
        }
      });
    },
    /**
     * 选择品牌
     */
    changeList(item, type) {
      if (type == 1) {
        if (item.checked) {
          getFollowCancelNew(item.pid)
            .then((res) => {
              this.getBrandLst();
              this.getFollowLstNew();
              return Toast({ message: res.msg });
            })
            .catch((err) => {
              return Toast({ message: err.msg });
            });
        } else {
          getFollowFollowNew(item.id)
            .then((res) => {
              this.getBrandLst();
              this.getFollowLstNew();
              return Toast({ message: res.msg });
            })
            .catch((err) => {
              return Toast({ message: err.msg });
            });
        }
      } else if (type == 2) {
        if (item.checked) {
          getFollowCancelNew(item.pid).then((res) => {
            this.getFollowLstNew();
            this.getBrandLst();
            return Toast({ message: res.msg });
          });
        } else {
          getBrandSaveNew({ title: item.title }).then((res) => {
            this.getFollowLstNew();
            this.getBrandLst();
            return Toast({ message: res.msg });
          });
        }
      }
    },
    // 创建品牌
    showAddBrandDialog() {
      if (this.inputVal.trim() == "") {
        return Toast({ message: "请先务必输入搜索品牌名！" });
      }
      this.addBrandDialog = true;
    },
    quxiaoAdd() {
      this.addBrandDialog = false;
    },
    // 确定创建品牌
    createdBrand() {
      getBrandSaveNew({ title: String(this.inputVal) })
        .then((res) => {
          this.addBrandDialog = false;
          this.brandList = [];
          this.cateList = [];
          this.getFollowLstNew();
          this.getBrandLst();
          return Toast({ message: res.msg });
        })
        .catch((err) => {
          return Toast(err.msg);
        });
    },
    // 移除我的关注
    getFollowCancelNew(e) {
      getFollowCancelNew(e).then((res) => {
        this.brandList = [];
        this.cateList = [];
        this.getFollowLstNew();
        this.getBrandLst();
        return Toast({ message: res.msg });
      });
    },
    setOpenShare() {
      if (isWeixin()) {
        getShare().then((res) => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: "https://jiaojiao.yanjiusuo.xyz",
            imgUrl: data.img,
          };
          openShareAll(configAppMessage);
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
body,
html {
  background-color: #fff !important;
}
</style>
